import { flatten, startCase, values } from "lodash";
import { ExportCategories, Frequency, ReportType } from "PFApp/analytics/types/export_analytics";
import { Template } from "PFApp/analytics/types/reports";

export const getTemplateReportType = (template: Template): ReportType => {
  if (template.groupBy) {
    return `${template.reportType}With${startCase(template.groupBy)}` as ReportType;
  }
  return template.reportType as ReportType;
};

export const getFrequencyByValue = (value: string) =>
  Frequency[Object.keys(Frequency)[Object.values<string>(Frequency).indexOf(value)]];

export const convertFieldsResponse = (fields: ExportCategories) =>
  flatten(values(fields).map((val) => values(val)));
